import React, { Component } from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'
import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'

import StarsRating from 'components/StarsRating'
import ShowDistance from 'components/ShowDistance'


export default (o) => {
	return(
	(!o.repairman)? <div></div>
	:<Link
		style={{
			textDecoration: 'none'
		}}
		key={o.repairman._id || 'All'}
		onClick={(evt) => {
			if(evt.target.className == 'assign-block'
				|| evt.target.parentNode.className == 'assign-block'
				|| evt.target.parentNode.parentNode.className == 'assign-block'
				|| evt.target.className == 'assign-element'
				|| evt.target.parentNode.className == 'assign-element'
				|| evt.target.parentNode.parentNode.className == 'assign-element'
			){
				evt.preventDefault()
				evt.stopPropagation()
				return false
			}
		}}
		to={(!o.repairman.isYelp)? (typeof global.md.phone() != 'string')?`/manager/repairmen/${o.id}`: `/manager/repairman/${o.id}`: ''}
		className="ent-card repairman-card"
	>
		<ListItem
			key={`repairmen-${o.id}`}
			style={{
				height: "80px"
			  , backgroundColor: (o.lastInteracted == o.id)? "#E8E8E8": "#FFF"
			  , overflow: 'hidden'
			  , paddingLeft:  (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" :"0px"
			  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "" : "0"
			  , border: "1px solid #e1e3e2"
			  , margin: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-2px 10px 0 10px" : "0 0 0 10px"
			  , width: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "100%" :"auto"
			}}
			key={o.repairman._id}
			leftAvatar={
				<div
					className="avatar"
					style={{
						marginTop: (typeof global.md.phone() == 'string')? "5px" : "-1px"
					  , marginLeft: (typeof global.md.phone() == 'string')? "auto" : "16px"
					  , width: "45px"
					  , height: "45px"
					  , backgroundColor: (typeof global.md.phone() == 'string')?
							  (o.repairman.tasksActive && o.repairman.tasksActive.length)?
								  "#d0d0d0"
								  :(!o.repairman.retired)?
										"#3cd2ae"
										  : "#d0d0d0"
							: "transparent"
					}}
				>
					<p
						className="counter-text"
						style={{
							width: "22px"
						  , height: "22px"
						  , lineHeight: "22px"
						  , borderRadius: "7px"
						  , textAlign: "center"
						  , marginTop: "13px"
						  , backgroundColor: (typeof global.md.phone() != 'string')?
								  (o.repairman.tasksActive && o.repairman.tasksActive.length)?
										"#000"
										:(!o.repairman.retired)?
											  "#3cd2ae"
											  :"#3cd2ae"
								: "transparent"
						  , color: "#FFF"
						}}
					>
						<span
							style={{
								fontSize: "12px"
	  						  , lineHeight: "9px"
							  , verticalAlign: "middle"
							}}
						>
							{(o.repairman.tasksDone)?o.repairman.tasksDone.length: 0}
						</span>
					</p>
				</div>
			}
			primaryText={
				<div>
					<p
						className="main-text"
						style={{
							position: "relative"
						  , maxWidth: "30%"
						  , fontSize: "14px"
						  , fontWeight: "bold"
						  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-15px": "2px"
						  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "2px" : "6px"
						  , marginBottom: "0px"
						  , textOverflow: "ellipsis"
						  , whiteSpace: "nowrap"
						  , overflow: "hidden"
						}}
					>
						{`${o.repairman.firstName}`}
					</p>
					<div
						className="secondary-text"
						style={{
							float: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "left" : "right"
						  , width: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "100vw" : "34.7%"
						  , marginTop: "7px"
						  , overflow: "hidden"
						}}
					>
						{(o.repairman.categories && o.repairman.categories.length)?
							<p style={{
									fontSize: "14px"
								  , position: "relative"
								  , paddingLeft: "0px"
								  , margin: '0'
								  , color: "#000000"
								  , top:"-1px"
								  , height: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "32px" : "auto"
								  , overflow: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "hidden" : "auto"
								  , left: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" : "40px"
								}}
							>
								{o.repairman.categories.map((category, indx, arr) =>
									(indx == 0 || o.repairman.id)?
										category
										: (arr && indx == arr.length -1)?
											` and ${category}`
											: `, ${category}`
								)}
							</p>
							: <p style={{fontSize: "12px", clear: "left", position: "relative", paddingLeft: "0px", margin: '0', color: "#000000"}}>No categories</p>
						}
					</div>
					<div
						className="assign-block"
						style={{
							position: "absolute"
						  , right: "30px"
						  , fontSize: "15px"
						  , lineHeight: "76px"
						  , top: "0"
						}}
					>

						{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
							""
							:<div
								style={{
									textDecoration: 'none'
								  , cursor: "pointer"
								  , display: (o.rightStackOpened && !o.refTask)? 'none': 'block'
								}}
								onClick={(evt) => {
									if(o.refTask){
										o.docUpd({_id: o.refTask, repairmanID: o.repairman._id})
										o.docUpd({_id: o.repairman._id, tasks: [...o.repairman.tasks, o.refTask]})
										this.props.go(`/manager/tasks/${o.refTask}`)
										evt.preventDefault()
										return false
									}else if(o.refQuoteProject){
										let newID = new Date().valueOf().toString() +'-'+ Math.random().toString(36).substr(2, 8)
										o.docUpd({
											_id: newID
										  , projectID: o.refQuoteProject
										  , vendorID: o.repairman._id
										  , vendor: o.repairman.firstName
										  , phone: (o.repairman.phoneNumber)?o.repairman.phoneNumber:""
										  , email: (o.repairman.email)?o.repairman.email:""
										  , status: "new"
										  , type: "quote"
										})
										this.props.go(`/manager/projects/${o.refQuoteProject}#repairmen`)
										evt.preventDefault()
										return false
									}else{
										o.history.push({
											pathname: `/manager/tasks`,
											state: { refRepMan: o.repairman._id }
										})
									}
								}}
								className="assign-element"
							>
									<svg
										width="22px"
										height="22px"
										viewBox="0 0 24 24"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlnsXlink="http://www.w3.org/1999/xlink"
										style={{
											verticalAlign: "middle"
										  , stroke: "#3cd2ae"
										}}
										className="assign-element"
									>
									    <defs></defs>
									    <g id="Page-1" stroke="none" strokeWdth="1" fill="none" fillRule="evenodd">
									        <g id="Group-2" transform="translate(1.000000, 1.000000)" stroke="#3cd2ae" strokeWidth="2">
									            <path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
									            <path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
									            <circle id="Oval-1" cx="11" cy="11" r="11"></circle>
									        </g>
									    </g>
									</svg>
									<span
										style={{
											verticalAlign: "middle"
										  , color: "#3cd2ae"
										  , marginLeft: "10px"
										}}
										className="assign-element hideable"
									>
										{(o.refTask)? "ASSIGN THIS REPAIRMAN TO TASK" : "ASSIGN NEW TASK"}
									</span>
								</div>
							}

					</div>
				</div>

			}
			secondaryText={
				(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
					""
					:<div
						style={{
							marginTop: "10px"
						}}
					>
						<StarsRating
							className="rating"
							style={{
								display: "inline-block"
							  , verticalAlign: "middle"
							  , marginLeft: "6px"
							}}
							size = "15px"
							color = "#808080"
							key={`${o.repairman._id}-${o.repairman.rating}`}
							value = {(o.repairman.rating)?o.repairman.rating:"0"}
						/>
						{(o.property._id && o.property._id != 'All')?
							<ShowDistance
								style={{
									display: "inline-block"
								  , color: "#3cd2ae"
								  , fontSize: "12px"
								  , verticalAlign: "middle"
								  , marginLeft: "10px"
								  , marginTop: "-7px"
								}}
								first={
									(o.repairman.cors && o.repairman.cors.lat)?
										o.repairman.cors
										: o.repairman.address.replace('\n', '+')
								}
								key={o.property._id}
								loaderSize={0.25}
								second={
									(
										o.property.cors
										&& o.property.cors.lat
									)?
										o.property.cors
										:
											(o.property)?
												o.property.address.replace('\n', '+')
												: "LOADING"
								}
								callBack={(newCors, type) =>{
									(type == "first")?
										o.docUpd({
											_id: o.repairman._id
										  , cors: newCors
										})
										:
										o.docUpd({
											_id: o.property._id
										  , cors: newCors
										})}
								}
							/>
							:""
						}
					</div>
			}
			secondaryTextLines={2}
			className="list-hover"
		>
		{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			<div
				className="distance"
				style={{float: "right", color: "#000", fontSize: "14px"}}>
				<br/>
				{(o.property._id && o.property._id != 'All')?
					<ShowDistance
						style={{
							float: 'right'
						  , marginTop: "7px"
						  , marginLeft: "10px"
						}}
						first={
							(o.repairman.cors && o.repairman.cors.lat)?
								o.repairman.cors
								: o.repairman.address.replace('\n', '+')
						}
						key={o.property._id}
						loaderSize={0.25}
						second={
							(
								o.property.cors
								&& o.property.cors.lat
							)?
								o.property.cors
								:
									(o.property)?
										o.property.address.replace('\n', '+')
										: "LOADING"
						}
						callBack={(newCors, type) =>{
							(type == "first")?
								o.docUpd({
									_id: o.repairman._id
								  , cors: newCors
								})
								:
								o.docUpd({
									_id: o.property._id
								  , cors: newCors
								})}
						}
					/>
					:""
				}
				<StarsRating
					className="rating"
					style={{
						float: "right"
					  , marginTop:"-7px"
					}}
					size = {(typeof global.md.phone() == 'string')? "13pt" : "12px"}
					color = "#808080"
					key={`${o.repairman._id}-${o.repairman.rating}`}
					value = {(o.repairman.rating)?o.repairman.rating:"0"}
				/>
			</div>
		: "" }
		</ListItem>
		{(typeof global.md.phone() == 'string')? <Divider style={{padding: "1"}} />: ""}
	</Link>
)}



// WEBPACK FOOTER //
// ./src/routes/manager/repairmen/RepairmanCard.js